import React from "react";
import { Button, Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan} from "@fortawesome/free-solid-svg-icons"; // Edit icon
import api from "../api";

const EventDetails = ({ event, typeList, onEdit, onDelete }) => {
  if (!event)
    return (
      <div className="text-center text-muted py-4">
        <p className="mb-0">Select an event to view its details</p>
      </div>
    );

  const type = typeList.find((t) => t.type_id === event.type_id)?.type_name;


  return (
    <Card className="shadow-sm border-0 mt-3">
      <Card.Body>
        <Card.Title className="mb-2 d-flex justify-content-between align-items-center">
          <h5 className="fw-bold">Detail</h5>
        <div className="text-end">
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => onEdit(event)}
          >
          <FontAwesomeIcon icon={faPenToSquare} className="me-2" /> Edit Event
          </Button>

          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => onDelete(event)}
            className="ms-2"
          >
          <FontAwesomeIcon icon={faTrashCan} className="me-2" /> Delete Event
          </Button>
        </div>

        </Card.Title>
        <Row className="mb-2">
          <Col xs={4} className="fw-semibold text-muted">Date:</Col>
          <Col>{event.date}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4} className="fw-semibold text-muted">Room:</Col>
          <Col>{event.event_room || "N/A"}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4} className="fw-semibold text-muted">Type:</Col>
          <Col>{type || "N/A"}</Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default EventDetails;
